@if (showAsDialog) {
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title">Invoice Detail</h4>
  </div>
}
@if (invoice) {
  <div class="modal-body p-0 flex-fill d-flex flex-column compact-form">
    <div class="card">
      <div class="card-body p-2 pb-3">
        <div class="btn-toolbar mx-0 mb-0 mt-0">
          <div>
            @if (hasChanges()) {
              <button class="btn btn-sm btn-primary me-2" (click)="save()">Save</button>
            }
            @if (hasChanges() && !showAsDialog) {
              <button class="btn btn-sm btn-success me-4" (click)="cancel()">Cancel</button>
            }
            @if (!hasChanges() && !showAsDialog) {
              <button class="btn btn-sm btn-primary me-4" (click)="close()">Close</button>
            }
            @if (!hasChanges()) {
              <button (click)="email()" class="btn btn-sm btn-primary me-2">Email Invoice</button>
            }
            @if (!hasChanges()) {
              <button class="btn btn-sm btn-primary me-4" (click)="print()">Print Invoice</button>
            }
            @if (!hasChanges()) {
              <button class="btn btn-sm btn-danger ms-4" (click)="delete()">Delete Invoice</button>
            }
            @if (!hasChanges() && !invoice.paid) {
              <button class="btn btn-sm btn-primary ms-4" (click)="receivePayment()">Receive Payment</button>
            }
          </div>
          <h3 style="margin-top: 0px !important; margin-left: 300px;">
            <strong [ngClass]="{ 'status-paid': true }">{{ invoice.invoiceType.name }}</strong>
          </h3>
          <div class="ms-auto d-flex align-items-center">
            <ng-container>
              <label class="mt-2 me-2">Type</label>
              <dx-select-box
                class="me-3"
                [width]="125"
                [(value)]="invoice.invoiceTypeId"
                [items]="invoiceTypes"
                [valueExpr]="'id'"
                [displayExpr]="'name'"
                [readOnly]="readOnly"
              ></dx-select-box>
              <label class="mt-2 me-2">Order Date</label>
              <dx-date-box class="me-3" [(value)]="invoice.invoiceDate" width="125px"></dx-date-box>
              <label class="mt-2 me-2">Due Date</label>
              <dx-date-box class="me-3" [(value)]="invoice.dueDate" width="125px"></dx-date-box>
            </ng-container>
            <label class="dx-box-item-content d-inline-block align-middle ms-4 me-2 mt-1">Status </label>
            <h3 style="margin-top: 0px !important">
              <strong [ngClass]="{ 'status-paid': invoice.statusId === InvoiceStatuses.Paid }">{{ invoice.statusName }}</strong>
            </h3>
          </div>
        </div>
        @if (invoice) {
          <dx-form [formData]="invoice" [colCount]="14" validationGroup="mainValidationGroup">
            <dxi-item itemType="group" caption="Customer" [colSpan]="3" [colCount]="1">
              <dxi-item [label]="{ text: 'Customer' }">
                <div *dxTemplate>
                  <dx-select-box
                    [(value)]="invoice.customerId"
                    [items]="customers"
                    valueExpr="id"
                    displayExpr="codeDisplayName"
                    searchMode="startswith"
                    (onValueChanged)="customerSelectionChanged($event)"
                    [readOnly]="readOnly || showAsDialog"
                    >
                  </dx-select-box>
                </div>
                <dxi-validation-rule type="required" [message]="'Customer Required'"></dxi-validation-rule>
              </dxi-item>
              @if (invoice) {
                <dxi-item dataField="customerTaxCode.name" [label]="{ text: 'Tax Code' }" [editorOptions]="{ disabled: true }"> </dxi-item>
              }
              <dxi-item itemType="group" [colSpan]="1" [colCount]="2">
                <dxi-item dataField="invoiceNumber" [label]="{ text: 'Invoice #' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                <dxi-item
                  dataField="pONumber"
                  [label]="{ text: 'PO Number' }"
                  [editorOptions]="{ readOnly: showAsDialog }"
                  [isRequired]="invoice.customer?.requirePoOnInvoices"
                  >
                </dxi-item>
              </dxi-item>
              @if (invoice.referencedInvoice) {
                <dxi-item [label]="{ text: 'Reference Invoice #' }">
                  <div *dxTemplate class="mb-2">
                    <a [routerLink]="['/invoices/' + invoice.referencedInvoiceId]">{{ invoice.referencedInvoice.invoiceNumber }}</a>
                  </div>
                </dxi-item>
                } @if (creditNumbers?.length > 0) {
                <dxi-item [label]="{ text: 'Credit #' }">
                  <div *dxTemplate class="mb-2 item-list">
                    @for (creditNumber of creditNumbers; track creditNumber.id) {
                      <a [routerLink]="['/invoices/' + creditNumber.id]">{{ creditNumber.invoiceNumber }}</a>
                    }
                  </div>
                </dxi-item>
              }
            </dxi-item>
            <dxi-item itemType="group" caption="Ship Address" [colSpan]="2">
              <dxi-item dataField="shipTo" [label]="{ visible: false }" editorType="dxTextArea" [editorOptions]="{ readOnly: showAsDialog, height: '115px' }"></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Info" [colSpan]="2">
              <dxi-item
                dataField="paymentMethodId"
                [label]="{ text: 'Method' }"
                editorType="dxSelectBox"
                [editorOptions]="{ items: paymentMethods, valueExpr: 'id', displayExpr: 'name', readOnly: showAsDialog }"
                [isRequired]="true"
              ></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Summary Total" [colSpan]="2">
              <dxi-item dataField="subTotal" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
              <dxi-item [label]="{ text: 'Taxable Sub' }">
                <div *dxTemplate>
                  <dx-number-box [value]="taxableSubTotal" [disabled]="true" [format]="'$#,##0.00##'"> </dx-number-box>
                </div>
              </dxi-item>
              <dxi-item dataField="tax" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
              <dxi-item dataField="total" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Payments" [colSpan]="2">
              <dxi-item
                dataField="paymentLinesTotal"
                [label]="{ text: 'Payments' }"
                editorType="dxNumberBox"
                [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
              ></dxi-item>
              <dxi-item [label]="{ text: 'Credits' }">
                <div *dxTemplate>
                  <dx-number-box [value]="creditAmount" format="$#,##0.00##" [readOnly]="true"></dx-number-box>
                </div>
              </dxi-item>
              <!-- <dxi-item
              dataField="unpaidBalance"
              editorType="dxNumberBox"
              [label]="{ text: 'Balance' }"
              [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
            ></dxi-item> -->
            <dxi-item dataField="balance" editorType="dxNumberBox" [label]="{ text: 'Balance' }" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
          </dxi-item>
          <!-- Attachments and Confirmations -->
          <dxi-item itemType="group" [colSpan]="3" [colCount]="1">
            <dxi-item itemType="group" caption="Attachments">
              <div *dxTemplate>
                @if (attachments) {
                  <ul style="list-style-type: none; padding-inline-start: 0px">
                    @for (attachment of attachments; track attachment) {
                      <li>
                        <a title="remove" (click)="removeAttachment(attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>
                        <a title="view" class="ms-1" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                      </li>
                    }
                  </ul>
                }
              </div>
            </dxi-item>
            <dxi-item>
              <div *dxTemplate>
                <dx-file-uploader
                  name="fileUpload"
                  selectButtonText="Select File(s)"
                  class="attachments"
                  accept="*"
                  uploadMode="instantly"
                  [showFileList]="false"
                  [multiple]="true"
                  [uploadUrl]="uploadUrl"
                  [uploadHeaders]="uploadHeader"
                  [disabled]="invoiceId === 'new'"
                  (onUploadStarted)="uploadStarted($event)"
                  (onUploadError)="uploadError($event)"
                  (onUploaded)="uploaded($event)"
                  >
                </dx-file-uploader>
              </div>
            </dxi-item>
          </dxi-item>
        </dx-form>
      }
    </div>
  </div>
  <!-- OrderLines Data Grid -->
  <div class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '400px' : '100%' }">
    <dx-data-grid
      #linesGrid
      height="200"
      [dataSource]="invoiceLines"
      keyExpr="id"
      [columnAutoWidth]="false"
      (onRowDblClick)="onRowDoubleClick($event)"
      (onRowPrepared)="rowPrepare($event)"
      (onCellPrepared)="onCellPrepared($event)"
      (onExporting)="onExporting($event)"
      class="lines-grid"
      >
      <dxi-column dataField="lineNumber" caption="Line #" width="90" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="loadId" width="80"></dxi-column>
      <dxi-column dataField="load.ticketNumber" caption="Ticket#" alignment="left" width="100"></dxi-column>
      <dxi-column dataField="partNumber" caption="Part #" width="150" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="description" caption="Description" width="300"></dxi-column>
      <dxi-column dataField="product.category.name" caption="Category" width="75"></dxi-column>
      <dxi-column dataField="unit" width="100"></dxi-column>
      <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" width="65"></dxi-column>
      <dxi-column dataField="price" [editorOptions]="{ step: 0 }" caption="Price" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
      <dxi-column dataField="lineTotal" caption="Total" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
      <dxi-column dataField="isTaxable" caption="Taxable" width="100"></dxi-column>
      <dxi-column dataField="tax" caption="Tax" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
      <!-- <dxi-column dataField="paymentTotal" caption="Payments" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column> -->
      <dxi-column dataField="notes" caption="Notes" width="150"></dxi-column>
      <dxi-column width="100"></dxi-column>
      <div *dxTemplate="let cell of 'linkTemplate'">
        @if (cell.data.productId && cell.data.product.material.name !== 'DELIVERY' && !cell.data.parentLineId && !cell.data.isMisc) {
          <div class="parent-part-number">
            {{ cell.text }}
          </div>
        }
        @if (cell.data.parentLineId || cell.data.isAdditive) {
          <div class="additive-part-number">{{ cell.text }}</div>
        }
        @if (cell.data.productId && cell.data.product.material.name === 'DELIVERY' && !cell.data.parentLineId && !cell.data.isMisc) {
          <div class="delivery-part-number">
            {{ cell.text }}
          </div>
        }
        @if (cell.data.isMisc) {
          <div class="misc-part-number">{{ cell.text }}</div>
        }
      </div>
      <dxo-summary>
        <dxi-total-item column="lineTotal" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 4 }"> </dxi-total-item>
      </dxo-summary>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button
          class="btn btn-sm btn-primary"
          (click)="move(linesGrid.instance.getSelectedRowsData()[0], 'up')"
          [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length !== 1"
          >
          <i class="fa fa-long-arrow-up" style="min-width: 15px"></i>
        </button>
        <button
          class="btn btn-sm btn-primary ms-2 me-4"
          (click)="move(linesGrid.instance.getSelectedRowsData()[0], 'down')"
          [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length !== 1"
          >
          <i class="fa fa-long-arrow-down" style="min-width: 15px"></i>
        </button>
        <button class="btn btn-sm btn-primary me-2" (click)="openLine()" [hidden]="showAsDialog" [disabled]="readOnly">Add Product</button>
        <button
          class="btn btn-sm btn-success me-2"
          (click)="addProductDelivery(linesGrid.instance.getSelectedRowsData())"
          [hidden]="showAsDialog"
          [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length === 0"
          >
          Add Product Delivery
        </button>
        <button class="btn btn-sm btn-success me-2" (click)="addDelivery()" [hidden]="showAsDialog" [disabled]="readOnly">Add Delivery</button>
        <button class="btn btn-sm btn-secondary me-2" (click)="addService()" [hidden]="showAsDialog" [disabled]="readOnly">Add Misc</button>
        <button
          class="btn btn-sm btn-danger me-2"
          (click)="removeLine(linesGrid.instance.getSelectedRowsData())"
          [hidden]="showAsDialog"
          [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length === 0"
          >
          Remove
        </button>
        <button
          class="btn btn-sm btn-warning"
          (click)="toggleIsTaxable(linesGrid.instance.getSelectedRowsData())"
          [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length === 0"
          >
          Toggle Tax
        </button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'"></div>
      <dxo-selection mode="multiple"></dxo-selection>
      <dxo-editing [mode]="'cell'" [allowUpdating]="!readOnly && !showAsDialog"></dxo-editing>
      <dxo-export [enabled]="true"></dxo-export>
      <dxo-state-storing [enabled]="true" [storageKey]="'invoice-detail-grid'"></dxo-state-storing>
    </dx-data-grid>
  </div>
  <div class="card">
    <div class="card-body">
      <dx-form #totalsForm [formData]="invoice" [colCount]="4">
        <dxi-item itemType="group" [colSpan]="2">
          <dxi-item [label]="{ text: 'Internal Notes' }">
            <div *dxTemplate>
              <dx-text-area [(value)]="invoice.notes" [height]="100"></dx-text-area>
            </div>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="1">
          <dxi-item dataField="quickBooksId" [editorOptions]="{ disabled: true }"> </dxi-item>
          <dxi-item dataField="quickBooksLastExport" [editorOptions]="{ displayFormat: 'shortDateShortTime', disabled: true }"> </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  </div>
</div>
}
@if (showAsDialog) {
  <div class="modal-footer">
    <button type="button" (click)="closeDialog()" class="btn btn-success ms-1">Close</button>
  </div>
}
